import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { NavLink } from "react-router-dom";

function Failed() {
  return (
    <>
    <div>
      <div className=" h-80 my-20 ">
        <div className="bg-white p-6 my-auto  md:mx-auto">
          <div className="text-center">
            <div className="message-box _success _failed ">
            <FontAwesomeIcon
                icon={faTimesCircle}
                className="mb-8"
                color="red"
                style={{scale:"3"}}
              />
              <h2> Your payment failed </h2>
              <p> Try again</p>
            </div>
            <div className="py-10 text-center">
              <NavLink
                to="/"
                className="px-12 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold py-3"
              >
                GO BACK
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default Failed;
